export class MaterialConstant {
  static TRANSPORT_AND_LIFTING_LABEL = "Transport & Levage";
  static AREMING_LABEL = "Armement";

  static OWNER_TYPE = {
    SEMS: "SEMS",
    COMAMA: "COMAMA",
  };

  static MACHINE_TYPE = {
    TRUCK: "TRUCK",
    ELEVATOR: "ELEVATOR",
    STACKER: "STACKER",
  };

  static TRANSPORT_AND_LIFTING_ID = "TRANSPORT_AND_LIFTING";
  static AREMING_ID = "ARMING";

  static MATERIAL_TYPE_OPTIONS = [
    {
      label: this.TRANSPORT_AND_LIFTING_LABEL,
      value: this.TRANSPORT_AND_LIFTING_ID,
    },
    {
      label: this.AREMING_LABEL,
      value: this.AREMING_ID,
    },
  ];
}
